import { collection, doc, runTransaction } from 'firebase/firestore';
import { db } from '../../services/firebase';

// Generate an ID without creating a document. Each saved edit owns its refresh.
export const createTimelineEditRevision = () => doc(collection(db, 'dailyLogs')).id;

export const applyCurrentTimelineRefresh = (updatedEntry, patch) => runTransaction(db, async (transaction) => {
  const ref = doc(db, 'dailyLogs', updatedEntry.id);
  const snapshot = await transaction.get(ref);
  if (!snapshot.exists()) return false;
  const current = snapshot.data();
  // The text check also protects against edits from an older client.
  if (current.timelineEditRevision !== updatedEntry.timelineEditRevision || current.text !== updatedEntry.text) return false;
  transaction.update(ref, patch);
  return true;
});
